
export type ListConversationsParams = {
/**
 * 페이지 번호 (0부터 시작)
 */
page?: number;
/**
 * 페이지 크기
 */
size?: number;
};
